var t=t=>{try{return t!==Symbol&&!!Reflect.construct(String,[],t)}catch(t){}return!1};export{t as default};